module.exports = __webpack_public_path__ + "img/button_record.fd08e269.png";